/** @jsxImportSource @emotion/react */
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import Toolbar from '@mui/material/Toolbar';
import { DMUKLogo } from '@omnigenbiodata/ui';

import Footer from '../Footer';
import ROUTES from '../../../core/constants/routes.constants';
import { useStyles } from './component.styles';

interface PortalLayoutProps {
  children: React.ReactNode;
}

function PortalLayout({ children }: PortalLayoutProps) {
  const classes = useStyles();

  return (
    <div css={classes.root} id="portalRoot">
      <Paper css={[classes.paper, classes.paperShaded]} elevation={4} id="paper">
        <Box mb={2}>
          <Toolbar disableGutters>
            <Box sx={{ flexGrow: 0 }}>
              <Link to={ROUTES.root}>
                <DMUKLogo size="sm" />
              </Link>
            </Box>
          </Toolbar>
        </Box>

        <Fade in timeout={500}>
          <Box css={classes.content}>{children}</Box>
        </Fade>

        <Footer />
      </Paper>
    </div>
  );
}

export default PortalLayout;
